import { Component, OnInit } from '@angular/core';

import { InvoicesService } from './invoices.service';

@Component({
  template: require('./invoices.component.html'),
  styles: [require('./invoices.component.scss')],
  providers: [InvoicesService]
})
export class InvoicesComponent implements OnInit {
  constructor(private service: InvoicesService) {
  }

  ngOnInit() {
    this.service.loaderOn = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/invoices/invoices.component.ts